import {useIntl} from "react-intl";
import * as React from "react";
import {useRef, useState} from "react";
import {OverlayPanel} from "primereact/overlaypanel";
import {Button} from "primereact/button";
import {PenaltyInvoiceService} from "../services/penalty-invoice-service";
import {useToast} from "../hooks/useToast";

interface Props {
  data: any;
  downloadHandler?: (fileId: number) => Promise<any>
}

export const DocumentPreview: React.FC<Props> = (props) => {
  const { formatMessage: f } = useIntl();
  const toastHelpers = useToast();
  const penaltyInvoicesService = new PenaltyInvoiceService(f, toastHelpers);
  const op = useRef<any>(null);
  const [url, setUrl] = useState<string>("");

  const handlePreviewFile = async (e: React.MouseEvent) => {
    op.current.toggle(e);
    if (url == "") {
      try {
        
        let blob: any = undefined;
        if(props.data.invoiceNumber && props.data.invoiceNumber !== ""){
          blob = await penaltyInvoicesService.downloadPenaltyInvoice(props.data.id);
        }else if(props.downloadHandler){
          blob = await props.downloadHandler(props.data.id);
        }else{
          console.error("Error downloading penalty invoice");
          return;
        }
        const url = URL.createObjectURL(blob);
        setUrl(url);
      } catch (error) {
        console.error("Error downloading penalty invoice:", error);
      }
    }
 
  };

  return (
    <>
      <Button
        icon={"pi pi-search-plus"}
        tooltip={f({ id: "preview" })}
        tooltipOptions={{ position: "top" }}
        onClick={handlePreviewFile}
        className={"p-button-info"}
      />
      <OverlayPanel ref={op} >
        <iframe style={{width: "600px", height: "600px"}} src={url}/>
      </OverlayPanel>
    </>
  );
};